<div [ngClass]="{'modal--xlg' : !configService.isMobile,'modal--mobile' : configService.isMobile}">
  <div class="modal__header" *ngIf="pdfLoaded">
    <div class="grid-row grid-row--aic">
      <div class="grid-col">
        <div class="h3"></div>
      </div>
      <div class="grid-col grid-col--auto">
        <button type="button" class="modal__close" (click)="closeModal()">
          <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none"
               stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    </div>
  </div>

  <div class="modal__cont">
    <pdf-viewer
      [src]="data"
      [original-size]="false"
      [zoom]="1"
      zoom-scale="page-width"
      [show-all]="true"
      class="d-block"
      (text-layer-rendered)="onLoad()"
    ></pdf-viewer>
  </div>
</div>
